import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PieChartThree } from "../../../../Constant";
import { PIE_THREE_CHART_DATA, PIE_THREE_CHART_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const PieChart3 = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={PieChartThree} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="pie-chart4">
            <Chart chartType="PieChart" width="100%" height="300px" data={PIE_THREE_CHART_DATA} options={PIE_THREE_CHART_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PieChart3;
